<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="about">
      申请交叉认证，我们将会有专人对您其他机构的认证卡片进行审核，审核通过后你将在SSI的系统中拥有一张交叉认证卡片。
    </div>
    <div :model="dataForm" class="whiteForm">

      <van-row>
        <van-col span="6">转入认证机构<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="OrganizationName" placeholder="请选择转入的认证机构" readonly @click="showOrganization =true">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">转入资质等级<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.oldLevel" placeholder="请填写在转入机构资质名称">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">转入机构学号</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.oldStudentId" placeholder="请填写在转入机构学号">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">转入证书编号<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.oldCertificateId" placeholder="请填写在转入机构证书编号">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">认证日期<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.oldRegDate" placeholder="请填写在转入机构获得认证的时间" readonly @click="showDateSelect=true">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">选择认证等级<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="CourseCode" placeholder="请选择认证等级" readonly @click="showCourseCode =true">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">上传证明材料<span class="mainColor">*</span></van-col>
        <van-col span="18">
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            multiple
            :max-count="3"
          />
        </van-col>
      </van-row>
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="info" :loading="buttonLoading" square @click="onAddCross">{{ dataForm.crossId == 0?'提交认证材料':'修改认证材料' }}</van-button>
    </div>

    <van-popup v-model="showOrganization" position="bottom">
      <van-picker
        show-toolbar
        title="选择组织"
        :columns="listOrganization"
        :visible-item-count="10"
        :default-index="OrganizationIndex"
        @cancel="showOrganization=false"
        @confirm="onConfirmOrganization"
      />
    </van-popup>
    <van-popup v-model="showCourseCode" position="bottom">
      <van-picker
        show-toolbar
        title="选择认证等级"
        :columns="listCourseCode"
        :visible-item-count="10"
        :default-index="CourseCodeIndex"
        @cancel="showCourseCode=false"
        @confirm="onCourseCode"
      />
    </van-popup>

    <van-popup v-model="showDateSelect" position="bottom">
      <van-datetime-picker
        v-model="oldRegDate"
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="onDateConfirm"
        @cancel="showDateSelect = false"
      />
    </van-popup>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, MyNotify, compressorImageList } from '@/utils/base'
import { Button, Popup, Picker, DatetimePicker, ImagePreview, Uploader, Image } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    [ImagePreview.name]: ImagePreview,
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    TopBar
  },
  data() {
    return {
      title: '申请交叉认证',
      backurl: '/textbook/crossCertificationList',
      buttonLoading: false,
      listOrganization: [
        { value: 'SSI', text: 'Scuba Schools International (issued but not listed)' },
        { value: 'ACUC', text: 'ACUC International' },
        { value: 'AIDA', text: 'AIDA International Freediving' },
        { value: 'ANDI', text: 'American Nitrox Divers' },
        { value: 'ANIS', text: 'Associazione Nazionale Istruttori Subacquei' },
        { value: 'APNEAA', text: 'Apnea Academy' },
        { value: 'Barakuda IDS', text: 'Barakuda International Diving Schools' },
        { value: 'BEFOS', text: 'Royal Belgian Diving Federation (BEFOS/FEBRAS)' },
        { value: 'BSAC', text: 'British Sub-Aqua Club' },
        { value: 'CEDIP', text: 'European Organisation for Professional Diving Instructors' },
        { value: 'CFT', text: 'Irish Underwater Council' },
        { value: 'CMAS', text: 'Conferderation Mondiale des Activites Subaquatiques' },
        { value: 'DACS', text: 'Diving Association of Central Sports' },
        { value: 'DAN', text: 'Divers Alert Network' },
        { value: 'DIWA', text: 'Diving Instructor World Association' },
        { value: 'DRI', text: 'Dive Rescue International ' },
        { value: 'DSF', text: 'Danish Sports Divers Federation' },
        { value: 'EOYDA', text: 'Hellenic Federation for Underwater Activities &amp; Sportfishing' },
        { value: 'ESA', text: 'European Scuba Association (non RSTC/ISO) + add Instructor Evaluation' },
        { value: 'FIAS', text: 'Federazione Italiana Attività Subacquea' },
        { value: 'FII', text: 'Freediving Instructors International' },
        { value: 'FIPSAS', text: 'Fedrazione Italiana Pesca Sportiva Attività Subacquea ' },
        { value: 'GUE', text: 'Global Underwater Explorers' },
        { value: 'IAC', text: 'International Aquanautic Club GmbH &amp; Co. KG' },
        { value: 'IANTD', text: 'Intl. Association of Nitrox and Technical Divers' },
        { value: 'IDA', text: 'International Diving Association' },
        { value: 'IDD', text: 'Instructor Dive Development' },
        { value: 'IDEA', text: 'International Diving Educators Association' },
        { value: 'IDIC', text: 'International Diving Instructor Corporation ' },
        { value: 'ISDA', text: 'International Scuba Diving Academy' },
        { value: 'JCS', text: 'The Association for The Advancement of Japan Submarine Technical Skill' },
        { value: 'JEFF', text: 'Japan Educational Facilities Federation Affiliated Member of CMAS' },
        { value: 'JP', text: 'Japan Professional Scuba Diving Instructors Association' },
        { value: 'JUDF', text: 'Japan Underwater Diving Federation' },
        { value: 'KDJAP', text: 'Kansai Sports Diving Federation Japan' },
        { value: 'NAD', text: 'National Diving Agency' },
        { value: 'NADD', text: 'NADD Global Diving Agency' },
        { value: 'NASDS', text: 'National Association of Scuba Diving Schools' },
        { value: 'NASE', text: 'National Academy Scuba Educator' },
        { value: 'NAUI', text: 'National Association of Underwater Instructors' },
        { value: 'NDL', text: 'National Diving League ' },
        { value: 'OTHERS', text: 'Agency not listed above (non RSTC/ISO) + add Instructor Evaluation' },
        { value: 'PADI', text: 'Professional Association of Diving Instructors' },
        { value: 'PDA', text: 'Professional Divers Association ' },
        { value: 'PDIC', text: 'The Professional Diving Instructors Corporation' },
        { value: 'PFI', text: 'Performance Freediving International' },
        { value: 'PRONRC', text: 'Pro NRC - Professional Nitrox &amp; Rebreather College' },
        { value: 'PROTEC', text: 'PROTEC INTERNATIONAL' },
        { value: 'PSAI', text: 'Professional Scuba Association International' },
        { value: 'PSS', text: 'Professional Scuba Schools' },
        { value: 'PTRD', text: 'Professional' },
        { value: 'RAID', text: 'Rebreather Association of International Divers (RAID)' },
        { value: 'SCUBA', text: 'S.C.U.B.A. AG' },
        { value: 'SDI', text: 'Scuba Diving International' },
        { value: 'SEI', text: 'Scuba Educators International' },
        { value: 'SNSI', text: 'Scuba Nitrox Safety International' },
        { value: 'STARS', text: 'Science Technology Associates of Rescue and Scuba' },
        { value: 'TDI', text: 'Technical Diving Intl.' },
        { value: 'TIDF', text: 'The Israeli Diving Federation' },
        { value: 'TSVOE', text: 'TSVOE Tauchsportverband Oesterreichs' },
        { value: 'UISP', text: 'Unione Italiana Sport Per tutti' },
        { value: 'VDST', text: 'Verband deutscher Sporttaucher e.V.' },
        { value: 'VDTL', text: 'Verband Deutscher Tauchlehrer (VDTL) e.V.' },
        { value: 'VIT', text: 'Verband Internationaler Tauchschulen' },
        { value: 'WASE', text: 'Worldwide Academy of Scuba Educators' },
        { value: 'WOSD', text: 'World Organisation of Scuba Diving' },
        { value: 'YMCA', text: 'YMCA SCUBA' },
        { value: 'AIDA', text: 'Association Internationale pour le Développement de l`Apnée' },
        { value: 'RFATA', text: 'Recognized First Aid Training Agency e.g. Red Cross' }
      ],
      listCourseCode: [],
      OrganizationName: undefined,
      showOrganization: false,
      OrganizationIndex: 0,

      CourseCode: undefined,
      showCourseCode: false,
      CourseCodeIndex: 0,

      showDateSelect: false,
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      oldRegDate: new Date(2010, 1, 1),

      fileList: [],
      dataForm: {
        crossId: undefined,
        oldOrganizationCode: undefined,
        oldOrganizationName: undefined,
        oldLevel: undefined,
        oldStudentId: undefined,
        oldCertificateId: undefined,
        oldRegDate: undefined,
        courseCode: undefined,
        courseName: undefined,
        oldResImg: undefined
      }
    }
  },
  watch: {
    oldRegDate(value) {
      this.dataForm.oldRegDate = formatDate(value, 'yyyy-MM-dd')
    }
  },
  activated() {
    this.minDate = new Date(1900, 1, 1)
  },
  created() {
    this.listOrganization.map((value, index, array) => {
      value.text = '(' + value.value + ') ' + value.text
    })
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.dataForm.crossId = this.$route.params.id
    this.loadlistCourseCode(this, () => {
      if (this.dataForm.crossId !== '0') {
        request({
          url: '/Activity/getCrossCertification',
          method: 'get',
          params: { id: this.dataForm.crossId }
        }).then(response => {
          if (!response.success) {
            return
          }
          this.dataForm = response.data
          this.OrganizationName = this.dataForm.oldOrganizationName
          this.CourseCode = this.dataForm.courseName
          this.dataForm.oldRegDate = formatDate(this.dataForm.oldRegDate, 'yyyy-MM-dd')
          this.oldRegDate = new Date(this.dataForm.oldRegDate)
          this.fileList = []
          var list = this.dataForm.oldResImg.split(',')
          list.map((value, index, array) => {
            this.fileList.push({
              content: value,
              file: undefined
            })
          })
          for (var i = 0; i < this.listCourseCode.length; i++) {
            if (this.listCourseCode[i].value === this.dataForm.courseCode) {
              this.CourseCodeIndex = i
              break
            }
          }
          for (var j = 0; j < this.listOrganization.length; j++) {
            if (this.listOrganization[j].value === this.dataForm.oldOrganizationCode) {
              this.OrganizationIndex = j
              break
            }
          }
        })
      }
    })
  },
  methods: {
    onConfirmOrganization(item) {
      console.log(item)
      this.dataForm.oldOrganizationCode = item.value
      this.dataForm.oldOrganizationName = item.text
      this.OrganizationName = item.text
      this.showOrganization = false
    },
    onCourseCode(item) {
      this.dataForm.courseCode = item.value
      this.dataForm.courseName = item.text
      this.CourseCode = item.text
      this.showCourseCode = false
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    onDateConfirm() {
      this.dataForm.oldRegDate = formatDate(this.oldRegDate, 'yyyy-MM-dd')
      this.showDateSelect = false
    },
    afterRead(file, detail) {
      console.log('file', this.fileList)
    },
    loadlistCourseCode(my, callback) {
      request({
        url: '/Activity/getCrossCertificationCourse',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        my.listCourseCode = response.data
        if (callback) {
          callback()
        }
      })
    },
    uploadFile(my, callback) {
      var noFile = true
      var fileList = []
      my.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback()
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=crosscertification',
          method: 'post',
          data: formData
        }).then(response => {
          if (!response.success) {
            my.buttonLoading = false
            return
          }
          var list = []
          my.fileList.map((value, index, array) => {
            if (!value.file) {
              list.push(value)
            }
          })
          response.data.map((value, index, array) => {
            list.push({
              content: value.save,
              file: undefined
            })
          })
          my.fileList = list
          if (callback) {
            callback()
          }
        })
      })
    },
    onAddCross() {
      if (!this.dataForm.oldOrganizationCode || this.dataForm.oldOrganizationCode.length <= 0) {
        MyNotify('info', '请选择转入认证机构')
        return
      }
      if (!this.dataForm.oldLevel || this.dataForm.oldLevel.length <= 0) {
        MyNotify('info', '请填写转入资质等级')
        return
      }
      if (!this.dataForm.oldCertificateId || this.dataForm.oldCertificateId.length <= 0) {
        MyNotify('info', '请填写转入证书编号')
        return
      }
      if (!this.dataForm.oldRegDate || this.dataForm.oldRegDate.length <= 0) {
        MyNotify('info', '请填写认证日期')
        return
      }
      if (!this.dataForm.courseCode || this.dataForm.courseCode.length <= 0) {
        MyNotify('info', '请选择认证等级')
        return
      }
      if (this.fileList.length <= 0) {
        MyNotify('info', '请上传证明材料')
        return
      }
      this.buttonLoading = true
      var my = this
      this.uploadFile(this, () => {
        console.log('fileList', my.fileList)
        var lists = []
        my.fileList.map((value, index, array) => {
          lists.push(value.content)
        })
        my.dataForm.oldResImg = lists.join(',')
        console.log('my.dataForm.oldResImg', my.dataForm.oldResImg)
        request({
          url: '/Activity/updateCrossCertification',
          method: 'post',
          data: my.dataForm
        }).then(response => {
          if (!response.success) {
            my.buttonLoading = false
            return
          }
          MyNotify('success', '材料提交成功，请等待审核!')
          this.$router.replace(my.backurl)
          return
        })
      })
    }
  }
}
</script>
<style scoped>
.downButton{
    position:fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
}
.downButton button{
    width: 100%;
}
.emptyRect{
    height: 3em;
}
.about{
    padding: 1em 1em 0 1em;
}
</style>
